
namespace TabAurous.Stock {

    @Serenity.Decorators.registerClass()
    export class JobTransactionSelectGrid extends _Ext.GridBase<JobTransactionRow, any> {
        protected getColumnsKey() { return 'Stock.JobTransaction'; } 
        protected getIdProperty() { return JobTransactionRow.idProperty; }
        protected getLocalTextPrefix() { return JobTransactionRow.localTextPrefix; } 
        protected getService() { return JobTransactionSelectService.baseUrl; }
        protected getInitialTitle() { return null; };

     
        constructor(container: JQuery, options) {
            super(container, options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            var partyid = options.GridFilters.PartyId;
            if (partyid != null && partyid > 0)
                (this.view.params as TransactionRequest).PartyId = partyid;
            var lineno = options.GridFilters.Line_No;
            if (lineno != null && lineno > 0)
                (this.view.params as TransactionRequest).Line_No = lineno;
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }

        private autoSize;
         
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): JobTransactionRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    } 
}